import React from "react";
import { useQuery } from "react-query";
import { useRecoilState } from "recoil";

import LocationIcon from "assets/images/svg/locations_blue (1).svg";
import PhoneIcon from "assets/images/svg/phone_blue.svg";

import { AddressAtom, ContactService } from "pages/contact-us/contact-us.service";
import { Spinner } from "react-bootstrap";
import ErrorMessage from "components/error/error";
import { json } from "helpers/data";

export default function AddressSlider() {
  const {
    data: Addresses = [],
    isLoading,
    isError,
    isSuccess
  } = useQuery("addresses", () => ContactService.getAddresses().then(({ response }) => response ?? []), {
    onSuccess(addresses) {
      setAddress(addresses[0]);
    }
  });
  const [address, setAddress] = useRecoilState(AddressAtom);
  const index = address ? Addresses.indexOf(address) : 0;

  const previous = () => index > 0 && setAddress(Addresses[index - 1]);
  const next = () => index < Addresses.length - 1 && setAddress(Addresses[index + 1]);

  return (
    <div className="addresses">
      {isSuccess && (
        <>
          <div className="header">
            <h1>
              {json(address?.city ?? "")}, {json(address?.country ?? "")}
            </h1>
            <div className="buttons">
              <button onClick={previous} disabled={index === 0}>
                <svg id="left_white" xmlns="http://www.w3.org/2000/svg" width="30" height="36" viewBox="0 0 30 36">
                  <rect id="Rectangle_12290" width="30" height="36" rx="8" fill="#fff" />
                  <g id="arrow_right_black_24dp" transform="translate(3 6)">
                    <path id="Path_47652" d="M24,0H0V24H24Z" fill="none" />
                    <path
                      id="Path_47653"
                      d="M12.883,15.29l-2.59-2.59a1,1,0,0,1,0-1.41l2.59-2.59a1,1,0,0,1,1.71.71v5.17A1,1,0,0,1,12.883,15.29Z"
                      transform="translate(-0.593)"
                      fill="#0074d7"
                    />
                  </g>
                </svg>
              </button>
              <button onClick={next} disabled={index === Addresses.length - 1}>
                <svg id="right_white" xmlns="http://www.w3.org/2000/svg" width="30" height="36" viewBox="0 0 30 36">
                  <rect id="Rectangle_12290" width="30" height="36" rx="8" fill="#fff" />
                  <g id="arrow_right_black_24dp" transform="translate(3 6)">
                    <path id="Path_47652" d="M0,0H24V24H0Z" fill="none" />
                    <path
                      id="Path_47653"
                      d="M11.71,15.29,14.3,12.7a1,1,0,0,0,0-1.41L11.71,8.7A1,1,0,0,0,10,9.41v5.17A1,1,0,0,0,11.71,15.29Z"
                      fill="#0074d7"
                    />
                  </g>
                </svg>
              </button>
            </div>
          </div>

          <div className="detail">
            <img src={LocationIcon} alt="add" />
            <p>
              {json(address?.street ?? "")}, {json(address?.city ?? "")}, {json(address?.country ?? "")}
            </p>
          </div>

          <div className="detail">
            <img src={PhoneIcon} alt="add" />
            <p>
              {address?.phone1} / {address?.phone2}
            </p>
          </div>

          <div className="dots">
            {Addresses.map((a, i) => (
              <span key={a.latitude} className={"dot" + (index === i ? " active" : "")} onClick={() => setAddress(a)} />
            ))}
          </div>
        </>
      )}

      {isLoading && (
        <div className="my-center">
          <Spinner variant="success" animation="grow" />
        </div>
      )}
      {isError && <ErrorMessage />}
    </div>
  );
}
